import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import { TopicWrapper, TopicPanel } from './styled';

import ListItem from '../../list-item';

const Topics = ({
    isExpanded,
    topicTree,
    invalidStrands,
    invalidStandards,
    updateTopicName,
    handleAddTopicModal,
    onDelete,
    selectTopic,
    onToggle,
    updateTopicExpand,
    onDragEnd
}) => {
    const [className, setClassName] = useState('');

    useLayoutEffect(() => {
        setClassName(isExpanded ? 'hideRow' : 'topics');
    }, [isExpanded]);

    const getGenericListItemProps = item => ({
        childNodes: item.childNodes,
        id: item.id.toString(),
        isEditable: item.isEditable,
        isExpanded: item.isExpanded,
        isSelected: item.isSelected,
        name: item.name,
        strand: item.strand,
        subStrand: item.subStrand
    });

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <TopicWrapper className={className}>
                <TopicPanel>
                    <Droppable droppableId="topicList">
                        {provided => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                            >
                                {topicTree.childNodes.map(
                                    (item, index) => (
                                        <div
                                            className="topicList"
                                            key={item.id}
                                        >
                                            <ListItem
                                                {...getGenericListItemProps(item)}
                                                getTopicName={updateTopicName}
                                                handleOnEdit={handleAddTopicModal}
                                                index={index}
                                                invalidStandards={invalidStandards}
                                                invalidStrands={invalidStrands}
                                                onDelete={onDelete}
                                                onItemSelect={selectTopic}
                                                onToggle={onToggle}
                                                showIconPanel
                                                updateTopics={updateTopicExpand}
                                            />
                                        </div>
                                    )
                                )}
                                {provided.placeholder}
                                <div className="dropZone" />
                            </div>
                        )}
                    </Droppable>
                </TopicPanel>
            </TopicWrapper>
        </DragDropContext>
    );
};

Topics.propTypes = {
    isExpanded: PropTypes.bool,
    topicTree: PropTypes.object,
    invalidStrands: PropTypes.array,
    invalidStandards: PropTypes.array,
    updateTopicName: PropTypes.func,
    handleAddTopicModal: PropTypes.func,
    onDelete: PropTypes.func,
    selectTopic: PropTypes.func,
    onToggle: PropTypes.func,
    updateTopicExpand: PropTypes.func,
    onDragEnd: PropTypes.func
};

export default Topics;



// WEBPACK FOOTER //
// ./app/components/course-creator/topics/index.js